var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 18L17.5 3C17.5 2.08333 16.75 1.33333 15.8333 1.33333L4.16667 1.33333C3.25 1.33333 2.5 2.08333 2.5 3L2.5 18C2.5 18.9167 3.25 19.6667 4.16667 19.6667L15.8333 19.6667C16.75 19.6667 17.5 18.9167 17.5 18ZM4.16667 18L4.16667 3L15.8333 3L15.8333 18L4.16667 18ZM7.5 4.66666L7.5 16.3333L5 16.3333L5 4.66666L7.5 4.66666Z",
    fill: "#354570"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse_icon.87e05c96867dd2028e430ff2d9578d00.svg";
export { ForwardRef as ReactComponent };